define([
    'lib/tentacle/tentacle',
    'modules/webanalytics/controls/profileselect2',
    'modules/webanalytics/controls/goalselect2',
    'modules/placements/controls/placementselect2',
    'modules/common/orders/controls/orderselect2',
    'modules/common/controls/labelselect2',
    'modules/common/controls/tagselect2',
    'modules/channels/controls/channelselect2',
    'modules/projects/controls/projectselect2',
    'modules/connectionsOld/controls/connectionselect2',
    'modules/common/controls/error'
], (Tentacle, ProfileSelect2, GoalSelect2, PlacementSelect2, OrderSelect2, LabelSelect2, TagSelect2,
    ChannelSelect2, ProjectSelect2, ConnectionSelect2, Error) => {

    // Registering most used custom controls
    Tentacle.registerControls({
        profileSelect2: ProfileSelect2,
        goalSelect2: GoalSelect2,
        placementSelect2: PlacementSelect2,
        orderSelect2: OrderSelect2,
        labelSelect2: LabelSelect2,
        tagSelect2: TagSelect2,
        channelSelect2: ChannelSelect2,
        projectSelect2: ProjectSelect2,
        connectionSelect2: ConnectionSelect2,
        error: Error
    });

});
